<template>
    <div class="card" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
        <div class="card-header" :id="id">
            <div class="mb-0">
                <button itemprop="name" class="btn btn-link" :class="{ 'collapsed': !visible }" type="button" data-toggle="collapse" :data-target="'#' + collapseId" aria-expanded="false" :aria-controls="collapseId">
                    <slot name="question"/>
                </button>
            </div>
        </div>
        <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer" :id="collapseId" class="collapse" :class="{ 'show': visible }"  :aria-labelledby="id" :data-parent="'#' + accordionId">
            <div itemprop="text" class="card-body" >
                <slot name="answer"/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['accordionId', 'id', 'collapseId', 'visible']
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/FaqAccord.vue